/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const planPriceDataSchema = z.object({
	id: z.string(),
	amount: z.number(),
	currency: z.string(),
})

export type PlanPriceDataSchema = z.infer<typeof planPriceDataSchema>
